<template>
    <scroll-box 
    :data="data" 
    :loading="loading"
    :total="total"
    :showMore="showMore"
    @loadMore="$emit('loadMore')">
        <template #left="scope">
            <img-record :src="scope.row.imgUrl" type="left"></img-record>
        </template>
        <template #right="scope">
            <img-record :src="scope.row.imgUrl" type="right"></img-record>
        </template>
    </scroll-box>
</template>
<script>
import scrollBox from './lib/scroll-box.vue'
import scrollBox2 from './lib/scroll-box2.vue'
import imgRecord from './lib/img-record.vue'
export default {
    components: { scrollBox,scrollBox2, imgRecord },
    props: {
        data: {
            type: Array,
            default() { return [] }
        },
        total: {
            type: Number,
            default() { return 0 }
        },
        loading: {
            type: Boolean,
            default() { return false }
        },
        showMore: {
            type: Boolean,
            default() { return false }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>